import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { HELPDESK } from '../../shared/constants/workspaces';
import { getAvailabilityManagementUrl } from '../../urls/inbox-urls';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAssignmentTooltip = ({
  disabled,
  isUngatedForHelpDeskRoutingScopeFiltering,
  workSpace
}) => {
  const isHelpDesk = workSpace === HELPDESK;
  if (isHelpDesk && isUngatedForHelpDeskRoutingScopeFiltering && disabled) {
    return null;
  }
  const commonProps = {
    elements: {
      Link
    },
    options: {
      external: true,
      href: isUngatedForHelpDeskRoutingScopeFiltering ? getUsersSeatsUrl() : getAvailabilityManagementUrl()
    }
  };
  if (isHelpDesk) {
    return isUngatedForHelpDeskRoutingScopeFiltering ? /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "routing-ui.routingRules.assignment.seats.ticketsTooltip_jsx"
    }, commonProps)) : /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "routing-ui.routingRules.assignment.seats.tickets_jsx"
    }, commonProps));
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
    message: "routing-ui.routingRules.assignment.seats.generic_jsx"
  }, commonProps));
};
const getAssignmentLabel = workSpace => workSpace === HELPDESK ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.routingRules.assignment.label.tickets"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.routingRules.assignment.label.generic"
});
export const RoutingTypeLabel = ({
  disabled,
  isUngatedForHelpDeskRoutingScopeFiltering,
  workSpace
}) => {
  const label = getAssignmentLabel(workSpace);
  const tooltip = getAssignmentTooltip({
    disabled,
    isUngatedForHelpDeskRoutingScopeFiltering,
    workSpace
  });
  if (tooltip) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [label, /*#__PURE__*/_jsx(HelpIcon, {
        alignWithText: true,
        marginInlineStart: "100",
        title: tooltip
      })]
    });
  }
  return label;
};
RoutingTypeLabel.displayName = 'RoutingTypeLabel';